// Import the functions you need from the SDKs you need
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import utils from "./Utils";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAgoNgUL0LYbM7zUkrODHMDM_xtIvB2vFw",
  authDomain: "rw-scanr.firebaseapp.com",
  databaseURL: "https://rw-scanr.firebaseio.com",
  projectId: "rw-scanr",
  storageBucket: "rw-scanr.appspot.com",
  messagingSenderId: "805195705220",
  appId: "1:805195705220:web:5593e0bd827fa4991ecbd1",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
  firebase.firestore();
  firebase.storage();
}

class IDBService {
  static getDB() {
    return firebase.firestore();
  }

  static async insertRequestWithResponse(request: any, response: any) {
    if (request?.KeyValues) {
      for (let key in request.KeyValues) {
        if (typeof request.KeyValues[key] === "string") {
          request.KeyValues[key] = request.KeyValues[key].substr(0, 5000);
        }
      }
    }
    const res = await firebase
      .firestore()
      .collection("requests")
      .add({
        request: JSON.parse(JSON.stringify(request)),
        createdAt: Date.now(),
        response: response ? JSON.parse(JSON.stringify(response)) : "",
        responseAt: Date.now(),
      });
    return res.id;
  }

  static async insertErrorLog(ex: any, tag = "", others: any = {}) {
    let message = utils.prepareErrorMessage(ex);
    this.insertRequestWithResponse(
      {
        ClassJOperationIC: 0,
        KeyValues: { ...ex, stack: ex.stack, message },
        options: {},
        url: "",
        tag: "ERROR",
      },
      { ex }
    );
  }

  static async insertRequest(obj: any) {
    const res = await firebase
      .firestore()
      .collection("requests")
      .add({
        request: JSON.parse(JSON.stringify(obj)),
        createdAt: Date.now(),
      });
    return res.id;
  }

  static async updateResponse(requestID: string, obj: any) {
    const res = await firebase
      .firestore()
      .collection("requests")
      .doc(requestID)
      .update({
        response: JSON.parse(JSON.stringify(obj)),
        responseAd: Date.now(),
      });
    return res;
  }

  static async uploadHtmlToStorage(fileName: string, html: string) {
    const ref = await firebase.storage().ref(`/apirequests/${fileName}`);
    const res = await ref.putString(html);
    return res;
  }
}

export default IDBService;

//@ts-ignore
window.IDBService = IDBService;
